import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./ServicesTab.css"
import ServiceCard from '../ServiceCard/ServiceCard';
import { axiosGet } from '../../../../utils/apis/api';
import Cookies from "js-cookie";
import { Paginations,SpinnerLoading } from '../../../../components';
import PrintIcon from '../../../../assets/images/packages/svg/print-icon.svg'
import { useTranslation } from "../../../../contexts/TranslationContext";

const ServicesTab = () => {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState(null);
  const [servicesData, setServicesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const resultsPerPage = 10;

  const fetchServices = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");

      const headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      const start = (pageNumber - 1) * resultsPerPage;

      const data = await axiosGet(
        "https://crm.alltimestravels.com/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation",
        {
          quotation_type: "Service",
          start,
          limit: resultsPerPage,
        },
        headers
      );

      if (data.result) {
        setServicesData(data.result.quotations || []);

        const meta = data.result.pagination?.metadata;
        if (meta) {
          setTotalPages(meta.total_pages || 1);
        } else {
          setTotalPages(Math.ceil((data.result.quotations?.length || 0) / resultsPerPage));
        }

        setCurrentPage(pageNumber);
      } else {
        setServicesData([]);
      }
    } catch (error) {
      console.error("Failed to fetch services:", error);
      setServicesData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices(currentPage);
  }, []);


  const onPageChange = (page) => {
    fetchServices(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  const handleClose = () => setSelectedService(null);
  // const servicesData = [
  //   {
  //     serviceType: "Visa Service",
  //     status: "completed",
  //     dateRange: "11 Nov 2025, 12:00 AM - 13 Nov 2025, 12:00 AM",
  //     visaType: "Jobseeker visit visa",
  //     nationality: "Syrian",
  //     destination: "UAE"
  //   },
  //   {
  //     serviceType: "Visa Service",
  //     status: "pending",
  //     dateRange: "15 Nov 2025, 12:00 AM - 17 Nov 2025, 12:00 AM",
  //     visaType: "Jobseeker visit visa",
  //     nationality: "Egyptian",
  //     destination: "UAE"
  //   }
  // ]
  return (
    <div>
      {loading ? (
          <div className="loading-container">
            <SpinnerLoading />
          </div>
      ) : servicesData.length > 0 ? (
        <>
          {servicesData.map((item, index) => (
            <ServiceCard
              key={index}
              serviceType={item.service_name || item.quotation_type}
              status={item.quotation_status}
              dateRange={`${item.start_date} - ${item.end_date}`}
              price={item.base_grand_total}
              destination={item.destinations?.[0]?.location}
              adults={item.number_of_adults}
              children={item.number_of_children}
              onClick={() => setSelectedService(item)} />
          ))}

          <div className="d-flex justify-content-center mt-5">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        </>
      ) : (
        <p>{t("NoServicesReserved")}</p>
      )}

      {selectedService && (
        <Modal show={true} onHide={handleClose} centered size="lg">
          <Modal.Header closeButton className="border-0 service-modal-header">
            <Modal.Title className="service-information">Visa Information</Modal.Title>
            <div className="ms-auto">
              <Button variant="link" className="service-information">
                {/* <img src={PrintIcon} className='print-icon'></img> */}
                 Print
              </Button>
            </div>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <div className="visa-info-container">
              <div className="visa-info-item">
                <h6 className="label">Full Name (as per passport)</h6>
                <p className="value">{selectedService.customer_name || "N/A"}</p>
              </div>

              <div className="visa-info-item">
                <h6 className="label">Date of Birth</h6>
                <p className="value">{selectedService.date_of_birth || "N/A"}</p>
              </div>

              <div className="visa-info-item">
                <h6 className="label">Nationality</h6>
                <p className="value">{selectedService.customer_nationality || "N/A"}</p>
              </div>

              <div className="visa-info-item">
                <h6 className="label">Gender</h6>
                <p className="value">{selectedService.gender || "N/A"}</p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  )
}

export default ServicesTab
